var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLoginProduct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 66,
    viewBox: "0 0 67 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.0963 57.9416C46.1243 61.4285 40.0532 63.4786 33.4999 63.4786C16.6554 63.4786 3 49.94 3 33.2393C3 16.5387 16.6554 3 33.4999 3C50.3446 3 64 16.5387 64 33.2393C64 38.4668 62.6625 43.3838 60.3071 47.6735L51.0963 57.9416ZM20.7498 51.4408V40.0488C20.7498 36.5864 23.5947 33.781 27.1037 33.7798H39.8963C43.4053 33.7798 46.2502 36.5864 46.2502 40.0488V51.4408H20.7498ZM33.4999 13.3866C37.4534 13.3866 40.659 16.5648 40.659 20.4844C40.659 24.4041 37.4534 27.5823 33.4999 27.5823C31.43 27.5823 29.5658 26.7112 28.2597 25.3188C27.0696 24.0516 26.341 22.3517 26.341 20.4843C26.341 16.5648 29.5465 13.3866 33.4999 13.3866Z",
    stroke: "white",
    strokeWidth: 4.57946,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLoginProduct);
export default __webpack_public_path__ + "static/media/Icon_Login_Product.6f52d256549b004243891de292904521.svg";
export { ForwardRef as ReactComponent };